import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SharedRoutingModule } from './shared-routing.module';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { StepProgressComponent } from './components/step-progress/step-progress.component';
import { HomeComponent } from './pages/home/home.component';
import { SafePipe } from '../core/pipes/safe-pipe';
import { CustomDatePipe } from '../core/pipes/custom-date.pipe';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { ModalComponent } from './components/modal/modal.component';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { PhotoCaptureComponent } from '../registration/pages/photo-upload/photo-capture/photo-capture.component';
import { DocumentUploadFormComponent } from '../registration/pages/scanned-document-upload/document-upload-form/document-upload-form.component';
import { BiometricConsentFormComponent } from './components/biometric-consent-form/biometric-consent-form.component';
import { CookieService } from 'ngx-cookie-service';
import { IncompleteOrderComponent } from './components/incomplete-order/incomplete-order.component';
import { ProductPriceComponent } from './components/product-price/product-price.component';
import { WebDeliveryRequirementsComponent } from './components/web-delivery-requirements/web-delivery-requirements.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { CreateAccountFormComponent } from './components/create-account-form/create-account-form.component';
import { SmsNotificationConsentComponent } from './components/sms-notification-consent/sms-notification-consent.component';
import { PasswordStrengthMeterComponent } from './components/password-strength-meter/password-strength-meter.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    LoadingComponent,
    StepProgressComponent,
    NotFoundComponent,
    HomeComponent,
    SafePipe,
    CustomDatePipe,
    PageTitleComponent,
    ModalComponent,
    AddressFormComponent,
    PhotoCaptureComponent,
    DocumentUploadFormComponent,
    BiometricConsentFormComponent,
    IncompleteOrderComponent,
    ProductPriceComponent,
    WebDeliveryRequirementsComponent,
    LoginFormComponent,
    CreateAccountFormComponent,
    SmsNotificationConsentComponent,
    PasswordStrengthMeterComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbModule,
    SharedRoutingModule,
    NgxIntlTelInputModule,
    RecaptchaModule,
  ],
  exports: [
    StepProgressComponent,
    LoadingComponent,
    HeaderComponent,
    FooterComponent,
    SafePipe,
    CustomDatePipe,
    PageTitleComponent,
    ModalComponent,
    AddressFormComponent,
    PhotoCaptureComponent,
    DocumentUploadFormComponent,
    BiometricConsentFormComponent,
    IncompleteOrderComponent,
    ProductPriceComponent,
    WebDeliveryRequirementsComponent,
    LoginFormComponent,
    CreateAccountFormComponent,
    SmsNotificationConsentComponent,
    PasswordStrengthMeterComponent,
    RecaptchaFormsModule,
    RecaptchaModule,
  ],
  providers: [
    CookieService,
  ]
})
export class SharedModule { }
